import { render, staticRenderFns } from "./TableNav.vue?vue&type=template&id=2796762c&"
import script from "./TableNav.vue?vue&type=script&lang=js&"
export * from "./TableNav.vue?vue&type=script&lang=js&"
import style0 from "./TableNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TableNav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports